import { render, staticRenderFns } from "./ProductReview.vue?vue&type=template&id=2565b328&scoped=true"
import script from "./ProductReview.vue?vue&type=script&lang=js"
export * from "./ProductReview.vue?vue&type=script&lang=js"
import style0 from "./ProductReview.vue?vue&type=style&index=0&id=2565b328&prod&scoped=true&lang=css"
import style1 from "./ProductReview.vue?vue&type=style&index=1&id=2565b328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2565b328",
  null
  
)

export default component.exports